export default "__VITE_ASSET__90e258e1__"